import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import Header from "@components/Header";
import Footer from "@components/Footer";
import { GENRES } from "@features/home/data/homeData";
import { contentApi } from "@services/contentApi";
import genrePattern from "@svg/pattern.png";
import "@styles/catalog.css";

export default function GenresPage() {
  const [genres, setGenres] = useState([]);

  useEffect(() => {
    contentApi.listGenres().then((items) => {
      setGenres(items.map((item, index) => ({ id: item._id, title: item.title, image: GENRES[index % GENRES.length].image })));
    }).catch(() => {});
  }, []);

  return <div className="catalog-page genres-page">
    <Header />
    <section className="genres-hero"><div className="catalog-container"><span>Выберите настроение</span><h1>Жанры</h1><p>Истории на любой вечер — от лёгких комедий до напряжённых триллеров.</p></div></section>
    <main className="catalog-container genres-main">
      <div className="genres-heading"><h2>Все жанры</h2><span>{genres.length} подборок</span></div>
      <div className="genres-grid">{genres.map((genre, index) => <Link className="genres-card" to={`/catalog?genre=${encodeURIComponent(genre.title)}`} key={`${genre.id}-${index}`}>
        <img className="genres-card-pattern" src={genrePattern} alt="" />
        <div className="genres-card-copy"><span>{String(index + 1).padStart(2, "0")}</span><h3>{genre.title}</h3><p>Смотреть подборку</p></div>
        <img className="genres-card-art" src={genre.image} alt="" />
        <span className="genres-card-arrow"><ArrowUpRight size={20} /></span>
      </Link>)}</div>
    </main>
    <Footer />
  </div>;
}
